/**
 * Stormport external endpoints
 */
import api from "@/utils/api-stormport.util";

export class AssetService {
  static RESOURCE = "/external/assets/";
  static RESOURCE_PROTECTED = "/assets/";

  static all(params = {}) {
    return api.get(this.RESOURCE_PROTECTED, { params });
  }

  static find(id, params = {}) {
    return api.get(this.RESOURCE + id, { params });
  }

  static geojson(params = {}) {
    return api.get(this.RESOURCE + "geojson", { params });
  }

  static create(data = {}) {
    return api.post(this.RESOURCE, data);
  }

  static assignTag(data = {}) {
    return api.post(this.RESOURCE + "assign-tag", data);
  }

  static unassignTag(data = {}) {
    return api.post(this.RESOURCE + "unassign-tag", data);
  }

  static codes(params = {}) {
    return api.get(this.RESOURCE + "codes", { params });
  }
}
